/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { TrfOrdIndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const trfOrdIndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  selectedDocuments: []
});

export const trfOrdIndexFetchTrfOrdIndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const trfOrdIndexFetchTrfOrdIndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const trfOrdIndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const trfOrdIndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const trfOrdIndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [TrfOrdIndexTypes.TRF_ORD_INDEX_RESET_TIMESTAMP]: trfOrdIndexResetTimestamp,
  [TrfOrdIndexTypes.TRF_ORD_INDEX_FETCH_TRF_ORD_INDEX_LOADING]: trfOrdIndexFetchTrfOrdIndexLoading,
  [TrfOrdIndexTypes.TRF_ORD_INDEX_FETCH_TRF_ORD_INDEX_SUCCESS]: trfOrdIndexFetchTrfOrdIndexSuccess,
  [TrfOrdIndexTypes.TRF_ORD_INDEX_ADD_SELECTED_DOCUMENTS]: trfOrdIndexAddSelectedDocuments,
  [TrfOrdIndexTypes.TRF_ORD_INDEX_REMOVE_SELECTED_DOCUMENTS]: trfOrdIndexRemoveSelectedDocuments,
  [TrfOrdIndexTypes.TRF_ORD_INDEX_SET_WORKSPACE_VISIBLE]: trfOrdIndexSetWorkspaceVisible
});
